import * as yup from 'yup';
import type { CreateSectionDto } from '../types';

type FileInputValue = File | { id: number; url: string };

export const sectionSchema: yup.ObjectSchema<CreateSectionDto> = yup.object({
  name: yup.string().required('Название обязательно'),
});

export const sectionFormSchema = sectionSchema.shape({
  image: yup
    .mixed<FileInputValue>()
    .optional()
    .nullable()
    .test('fileSize', 'Размер файла не должен превышать 10MB', (value) => {
      if (!value || !(value instanceof File)) return true;
      return value.size <= 10 * 1024 * 1024;
    })
    .test('fileType', 'Разрешены только изображения (JPEG, PNG, WebP)', (value) => {
      if (!value || !(value instanceof File)) return true;
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
      return allowedTypes.includes(value.type);
    })
    .test('requiredImage', 'Добавьте изображение', function (value) {
      if (!this.options.context?.requireImage) return true;
      return value instanceof File;
    }),
}) as yup.ObjectSchema<{ name: string; image?: FileInputValue | null }>;

